module.exports = __webpack_public_path__ + "img/BRCA3_Treg.6de2f26b.png";